import $ from 'jquery';
import 'superfish';
import { jumplinks } from './_utilities';

/**
 * Inner page sidebar navigation script.
 */
$(document).ready(function(){
	// Initialize Superfish menu
	jQuery('#main_menu menu').superfish({
		delay: 300,
		speed: 0,
		speedOut: 0,
	});

	// Add 'current' class to current page anchor
	$('#main_menu a').each((item, object) => {
		$(object)[0].pathname === location.pathname &&
		$(object)[0].hash === '' ? $(object).addClass('current') : '';
	});
});

jumplinks('#main_menu');

// Member Menu Unrestricted

$(document).ready(function(){
	// Initialize Superfish menu
	jQuery('#user_menu ul').superfish({
		delay: 300,
		speed: 0,
		speedOut: 0,
	});

	// Add 'current' class to current page anchor
	$('#user_menu a').each((item, object) => {
		$(object)[0].pathname === location.pathname &&
		$(object)[0].hash === '' ? $(object).addClass('current') : '';
	});
});

jumplinks('#user_menu');

// Member Menu Claims Management

$(document).ready(function(){
	// Initialize Superfish menu
	jQuery('#claims_menu ul').superfish({
		delay: 300,
		speed: 0,
		speedOut: 0,
	});

	// Add 'current' class to current page anchor
	$('#claims_menu a').each((item, object) => {
		$(object)[0].pathname === location.pathname &&
		$(object)[0].hash === '' ? $(object).addClass('current') : '';
	});
});

jumplinks('#claims_menu');

/*************** Submenu ***************/
jumplinks('#submenu');

/*************** Mobile Menu ***************/
const main_menu = $('.main-menu menu').clone().html();
const mobile_menu_overlay = '<div class="mobile-menu-overlay off" id="mobile_menu_overlay"></div>';
const mobile_menu_modal = `<div class="mobile-menu off" id="mobile_menu_generated"><ul><li><a href="/">Home</a></li>${main_menu}</ul></div>${mobile_menu_overlay}`;

$('body').prepend(mobile_menu_modal);

const mobile_menu_generated = '#mobile_menu_generated';

jumplinks(mobile_menu_generated);

$(mobile_menu_generated).find('a').siblings('ul').each((index, element) => {
	$(element).before('<a href="" class="toggle">SubMenu Toggle</a>');
});

$(mobile_menu_generated).find('.toggle').on('click', function(event) {
	event.preventDefault();

	$(this).siblings('ul').slideToggle();
});

$('#mobile_menu_toggle').on('click', function(event) {
	event.preventDefault();

	$(this).toggleClass('is-active');
	$('#mobile_menu_overlay').toggleClass('off');
	$(mobile_menu_generated).toggleClass('off');
});



// WEBPACK FOOTER //
// ./theme_components/js/modules/_menus.js